module.exports = __webpack_public_path__ + "img/left_right_layout_3.2589a5f7.svg";